export const salesTypes = {
    FETCH_SALES_ORDER_LIST_REQUEST: "FETCH_SALES_ORDER_LIST_REQUEST",
    FETCH_SALES_ORDER_LIST_SUCCESS: "FETCH_SALES_ORDER_LIST_SUCCESS",
    FETCH_SALES_ORDER_LIST_FAILURE: "FETCH_SALES_ORDER_LIST_FAILURE",
    CREATE_SALES_ORDER_REQUEST: "CREATE_SALES_ORDER_REQUEST",
    CREATE_SALES_ORDER_SUCCESS: "CREATE_SALES_ORDER_SUCCESS",
    CREATE_SALES_ORDER_FAILURE: "CREATE_SALES_ORDER_FAILURE",
    FETCH_SINGLE_SALES_ORDER_REQUEST: "FETCH_SINGLE_SALES_ORDER_REQUEST",
    FETCH_SINGLE_SALES_ORDER_SUCCESS: "FETCH_SINGLE_SALES_ORDER_SUCCESS",
    FETCH_SINGLE_SALES_ORDER_FAILURE: "FETCH_SINGLE_SALES_ORDER_FAILURE",
    FETCH_SALES_DASHBOARD_STATS_REQUEST: "FETCH_SALES_DASHBOARD_STATS_REQUEST",
    FETCH_SALES_DASHBOARD_STATS_SUCCESS: "FETCH_SALES_DASHBOARD_STATS_SUCCESS",
    FETCH_SALES_DASHBOARD_STATS_FAILURE: "FETCH_SALES_DASHBOARD_STATS_FAILURE",
    FETCH_SALES_TOP_AND_LEAST_PRODUCTS_REQUEST: "FETCH_SALES_TOP_AND_LEAST_PRODUCTS_REQUEST",
    FETCH_SALES_TOP_AND_LEAST_PRODUCTS_SUCCESS: "FETCH_SALES_TOP_AND_LEAST_PRODUCTS_SUCCESS",
    FETCH_SALES_TOP_AND_LEAST_PRODUCTS_FAILURE: "FETCH_SALES_TOP_AND_LEAST_PRODUCTS_FAILURE",
    FETCH_SALES_VELOCITY_STAT_REQUEST: "FETCH_SALES_VELOCITY_STAT_REQUEST",
    FETCH_SALES_VELOCITY_STAT_SUCCESS: "FETCH_SALES_VELOCITY_STAT_SUCCESS",
    FETCH_SALES_VELOCITY_STAT_FAILURE: "FETCH_SALES_VELOCITY_STAT_FAILURE",
    FETCH_SALES_CHANNEL_STAT_REQUEST: "FETCH_SALES_CHANNEL_STAT_REQUEST",
    FETCH_SALES_CHANNEL_STAT_SUCCESS: "FETCH_SALES_CHANNEL_STAT_SUCCESS",
    FETCH_SALES_CHANNEL_STAT_FAILURE: "FETCH_SALES_CHANNEL_STAT_FAILURE",
    FETCH_CUSTOMER_LIST_REQUEST: "FETCH_CUSTOMER_LIST_REQUEST",
    FETCH_CUSTOMER_LIST_SUCCESS: "FETCH_CUSTOMER_LIST_SUCCESS",
    FETCH_CUSTOMER_LIST_FAILURE: "FETCH_CUSTOMER_LIST_FAILURE",
    FETCH_SALES_TOP_AND_LEAST_REGIONS_REQUEST: "FETCH_SALES_TOP_AND_LEAST_REGIONS_REQUEST",
    FETCH_SALES_TOP_AND_LEAST_REGIONS_SUCCESS: "FETCH_SALES_TOP_AND_LEAST_REGIONS_SUCCESS",
    FETCH_SALES_TOP_AND_LEAST_REGIONS_FAILURE: "FETCH_SALES_TOP_AND_LEAST_REGIONS_FAILURE",
    CREATE_SALES_SHIPMENT_REQUEST: "CREATE_SALES_SHIPMENT_REQUEST",
    CREATE_SALES_SHIPMENT_SUCCESS: "CREATE_SALES_SHIPMENT_SUCCESS",
    CREATE_SALES_SHIPMENT_FAILURE: "CREATE_SALES_SHIPMENT_FAILURE",
    UPDATE_SALES_ORDER_REQUEST: "UPDATE_SALES_ORDER_REQUEST",
    UPDATE_SALES_ORDER_SUCCESS: "UPDATE_SALES_ORDER_SUCCESS",
    UPDATE_SALES_ORDER_FAILURE: "UPDATE_SALES_ORDER_FAILURE",
    FETCH_TOP_AND_LEAST_SALES_TYPE_REQUEST: "FETCH_TOP_AND_LEAST_SALES_TYPE_REQUEST",
    FETCH_TOP_AND_LEAST_SALES_TYPE_SUCCESS: "FETCH_TOP_AND_LEAST_SALES_TYPE_SUCCESS",
    FETCH_TOP_AND_LEAST_SALES_TYPE_FAILURE: "FETCH_TOP_AND_LEAST_SALES_TYPE_FAILURE",
    FETCH_TOP_AND_LEAST_RETAILS_SALES_REQUEST: "FETCH_TOP_AND_LEAST_RETAILS_SALES_REQUEST",
    FETCH_TOP_AND_LEAST_RETAILS_SALES_SUCCESS: "FETCH_TOP_AND_LEAST_RETAILS_SALES_SUCCESS",
    FETCH_TOP_AND_LEAST_RETAILS_SALES_FAILURE: "FETCH_TOP_AND_LEAST_RETAILS_SALES_FAILURE",
    UPDATE_MULTIPLE_SALES_ORDER_STATUS_REQUEST: "UPDATE_MULTIPLE_SALES_ORDER_STATUS_REQUEST",
    UPDATE_MULTIPLE_SALES_ORDER_STATUS_SUCCESS: "UPDATE_MULTIPLE_SALES_ORDER_STATUS_SUCCESS",
    UPDATE_MULTIPLE_SALES_ORDER_STATUS_FAILURE: "UPDATE_MULTIPLE_SALES_ORDER_STATUS_FAILURE",
    FETCH_SALES_SUMMARY_REQUEST: "FETCH_SALES_SUMMARY_REQUEST",
    FETCH_SALES_SUMMARY_SUCCESS: "FETCH_SALES_SUMMARY_SUCCESS",
    FETCH_SALES_SUMMARY_FAILURE: "FETCH_SALES_SUMMARY_FAILURE",
    DELETE_SALES_ORDER_REQUEST: "DELETE_SALES_ORDER_REQUEST",
    DELETE_SALES_ORDER_SUCCESS: "DELETE_SALES_ORDER_SUCCESS",
    DELETE_SALES_ORDER_FAILURE: "DELETE_SALES_ORDER_FAILURE",
    FETCH_SALES_ORDER_AGENTS_REQUEST: "FETCH_SALES_ORDER_AGENTS_REQUEST",
    FETCH_SALES_ORDER_AGENTS_SUCCESS: "FETCH_SALES_ORDER_AGENTS_SUCCESS",
    FETCH_SALES_ORDER_AGENTS_FAILURE: "FETCH_SALES_ORDER_AGENTS_FAILURE",
    // Pin/Unpin functionality
    PIN_SALES_ORDER_REQUEST: "PIN_SALES_ORDER_REQUEST",
    PIN_SALES_ORDER_SUCCESS: "PIN_SALES_ORDER_SUCCESS",
    PIN_SALES_ORDER_FAILURE: "PIN_SALES_ORDER_FAILURE",
    UNPIN_SALES_ORDER_REQUEST: "UNPIN_SALES_ORDER_REQUEST",
    UNPIN_SALES_ORDER_SUCCESS: "UNPIN_SALES_ORDER_SUCCESS",
    UNPIN_SALES_ORDER_FAILURE: "UNPIN_SALES_ORDER_FAILURE",
    BULK_PIN_SALES_ORDER_REQUEST: "BULK_PIN_SALES_ORDER_REQUEST",
    BULK_PIN_SALES_ORDER_SUCCESS: "BULK_PIN_SALES_ORDER_SUCCESS",
    BULK_PIN_SALES_ORDER_FAILURE: "BULK_PIN_SALES_ORDER_FAILURE",
    BULK_UNPIN_SALES_ORDER_REQUEST: "BULK_UNPIN_SALES_ORDER_REQUEST",
    BULK_UNPIN_SALES_ORDER_SUCCESS: "BULK_UNPIN_SALES_ORDER_SUCCESS",
    BULK_UNPIN_SALES_ORDER_FAILURE: "BULK_UNPIN_SALES_ORDER_FAILURE",
    // Reset action types
    RESET_PIN_SALES_ORDER_SUCCESS: "RESET_PIN_SALES_ORDER_SUCCESS",
    RESET_UNPIN_SALES_ORDER_SUCCESS: "RESET_UNPIN_SALES_ORDER_SUCCESS",
    RESET_BULK_PIN_SALES_ORDER_SUCCESS: "RESET_BULK_PIN_SALES_ORDER_SUCCESS",
    RESET_BULK_UNPIN_SALES_ORDER_SUCCESS: "RESET_BULK_UNPIN_SALES_ORDER_SUCCESS",
    // Sales Settings functionality
    FETCH_SALES_SETTINGS_REQUEST: "FETCH_SALES_SETTINGS_REQUEST",
    FETCH_SALES_SETTINGS_SUCCESS: "FETCH_SALES_SETTINGS_SUCCESS",
    FETCH_SALES_SETTINGS_FAILURE: "FETCH_SALES_SETTINGS_FAILURE",
    UPDATE_SALES_SETTINGS_REQUEST: "UPDATE_SALES_SETTINGS_REQUEST",
    UPDATE_SALES_SETTINGS_SUCCESS: "UPDATE_SALES_SETTINGS_SUCCESS",
    UPDATE_SALES_SETTINGS_FAILURE: "UPDATE_SALES_SETTINGS_FAILURE",
    RESET_FETCH_SALES_SETTINGS_SUCCESS: "RESET_FETCH_SALES_SETTINGS_SUCCESS",
    RESET_UPDATE_SALES_SETTINGS_SUCCESS: "RESET_UPDATE_SALES_SETTINGS_SUCCESS",
};
